'use strict';

var chunkM632V57T_js = require('./chunk-M632V57T.js');

var t=()=>({1:{fontSize:chunkM632V57T_js.a.font_size_5xl,lineHeight:chunkM632V57T_js.a.font_line_height_6xl_small},2:{fontSize:chunkM632V57T_js.a.font_size_4xl,lineHeight:chunkM632V57T_js.a.font_line_height_5xl},3:{fontSize:chunkM632V57T_js.a.font_size_3xl,lineHeight:chunkM632V57T_js.a.font_line_height_4xl},4:{fontSize:chunkM632V57T_js.a.font_size_2xl,lineHeight:chunkM632V57T_js.a.font_line_height_3xl}});

exports.a = t;
